module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/create.js
// module id = 2279
// module chunks = 0